import React from 'react';
import { useAITTheme } from '@this/shared/ui/theme';
import type { UnsupportedRequest } from '../../types/messages';

type Props = {
  unsupportedRequest: UnsupportedRequest;
};

const UnsupportedRequestMessage = ({ unsupportedRequest }: Props) => {
  const { theme } = useAITTheme();

  return (
    <div style={styles.card}>
      <div style={styles.title}>{unsupportedRequest.title}</div>
      <div style={styles.list}>
        {unsupportedRequest.supportedProducts.map(product => (
          <div key={product} style={styles.listItem}>
            ・{product}
          </div>
        ))}
      </div>
      <div style={styles.description}>{unsupportedRequest.description}</div>
      <a
        href={unsupportedRequest.dashboardPath}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          ...styles.linkButton,
          backgroundColor: theme.linkColor || '#1f6feb'
        }}
      >
        {unsupportedRequest.dashboardLabel}
      </a>
    </div>
  );
};

const styles = {
  card: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '12px',
    padding: '18px',
    borderRadius: '16px',
    border: '1px solid #d7e3db',
    backgroundColor: '#f5faf7',
    boxShadow: '0 8px 24px rgba(20, 55, 90, 0.06)'
  },
  title: {
    color: '#14374a',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 1.6
  },
  list: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '6px',
    color: '#24435e',
    fontSize: '14px',
    lineHeight: 1.6
  },
  listItem: {
    color: '#24435e'
  },
  description: {
    color: '#456173',
    fontSize: '13px',
    lineHeight: 1.7
  },
  linkButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'fit-content',
    minHeight: '40px',
    padding: '0 16px',
    borderRadius: '999px',
    backgroundColor: '#2d7a55',
    color: '#ffffff',
    fontSize: '13px',
    fontWeight: 700,
    textDecoration: 'none'
  }
};

export default UnsupportedRequestMessage;
